var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import intercom from "@irati/utils/intercom";
import FormattedMessage from "@irati/utils/lang";
import { TenantOnboardingStepStates } from "@irati/types";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import { Footer } from "./styled";
import { SetupSteps } from "../../constants/stepConfig";
import { TENANT_SETUP_TOUR_PREFIX } from "../../tour";
var CompleteStepFooter = /** @class */ (function (_super) {
    __extends(CompleteStepFooter, _super);
    function CompleteStepFooter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Ensure the intercom help bubble is never shown over the footer
        _this.componentWillMount = function () { return intercom.hide(); };
        _this.componentWillUnmount = function () { return intercom.show(); };
        return _this;
    }
    CompleteStepFooter.prototype.render = function () {
        var _a = this.props, state = _a.state, handleSkip = _a.handleSkip, handleMarkComplete = _a.handleMarkComplete, handleNextStep = _a.handleNextStep, completable = _a.completable, stepId = _a.stepId;
        var isStepDone = state === TenantOnboardingStepStates.Done;
        var isStepSkipped = state === TenantOnboardingStepStates.Skipped;
        var isInviteStep = stepId === SetupSteps.INVITE || stepId === SetupSteps.SETUP_SSO;
        var skipStepHandler = isStepDone || isStepSkipped ? handleNextStep : handleSkip;
        var skipStepKey = isStepDone || isStepSkipped ? "setup_tenant.footer.nextStep" : "setup_tenant.footer.skipStep";
        if (isInviteStep) {
            return (React.createElement(Footer, null,
                React.createElement(Flex, { alignItems: "center", justifyContent: "flex-end" },
                    React.createElement(Button, { primary: true, inverted: true, "data-tour": TENANT_SETUP_TOUR_PREFIX + "step02", disabled: !completable, onClick: handleMarkComplete },
                        React.createElement(FormattedMessage, { id: "setup_tenant.footer.finishSetup" })))));
        }
        return (React.createElement(Footer, null,
            React.createElement(Flex, { "data-tour": TENANT_SETUP_TOUR_PREFIX + "step02", alignItems: "center", justifyContent: "flex-end" },
                React.createElement(Button, { onClick: skipStepHandler, primary: isStepDone, inverted: true, marginRight: 2 },
                    React.createElement(FormattedMessage, { id: skipStepKey })),
                !isStepDone && (React.createElement(Button, { disabled: !completable, onClick: handleMarkComplete, primary: true, inverted: true, marginRight: 2 },
                    React.createElement(FormattedMessage, { id: "setup_tenant.footer.markComplete" }))))));
    };
    return CompleteStepFooter;
}(PureComponent));
export default CompleteStepFooter;
